var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:(_vm.colourStyle()),attrs:{"disabled":!_vm.enabled},on:{"click":_vm.onClick}},[_c('span',[(_vm.icon)?_c('FontAwesomeIcon',{attrs:{"icon":_vm.icon}}):_vm._e()],1),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }